import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './suggestion-heading.styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SuggestionHeading = _ref => {
  var children = _ref.children;
  return ___EmotionJSX("div", {
    css: styles.suggestionHeading
  }, children);
};
SuggestionHeading.propTypes = {
  children: PropTypes.node.isRequired
};
export default SuggestionHeading;